import { useEffect } from "react";
import { Outlet, useParams, Navigate } from "react-router-dom";
import { LANGS, RTL_LANGS } from "@/lib/api";
import Header from "@/components/public/Header";
import Footer from "@/components/public/Footer";
import WhatsAppFloat from "@/components/public/WhatsAppFloat";
import MobileContactBar from "@/components/public/MobileContactBar";
import CookieConsent from "@/components/public/CookieConsent";

export default function PublicLayout() {
  const { lang } = useParams();

  useEffect(() => {
    if (LANGS.includes(lang)) {
      document.documentElement.setAttribute("lang", lang);
      document.documentElement.setAttribute("dir", RTL_LANGS.includes(lang) ? "rtl" : "ltr");
    }
  }, [lang]);

  if (!LANGS.includes(lang)) return <Navigate to="/tr" replace />;

  return (
    <div className={`min-h-screen flex flex-col pb-12 lg:pb-0 ${RTL_LANGS.includes(lang) ? "font-fa" : ""}`}>
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <MobileContactBar />
      <CookieConsent />
    </div>
  );
}
